import { LmgService } from "../resource";

// Quick Payment (Issue #2) — รับชำระที่สาขา
const QuickPayModule = {
  namespaced: true,
  state: {
    // รายการ billing ที่ค้นเจอจากการ lookup policy (ตะกร้ายังจัดการในหน้า)
    lookup: [],
    // บัญชี PromptPay ของสาขา
    promptpay: [],
    payment_method: [
      { ID: 1, Name: "เงินสด" },
      { ID: 3, Name: "เงินโอน" },
      { ID: 6, Name: "QR PromptPay" },
    ],
    isLooking: false,
    _lookupSeq: 0,
  },
  mutations: {
    SET_LOOKUP(state, payload) {
      state.lookup = payload;
    },
    SET_PROMPTPAY(state, payload) {
      state.promptpay = payload;
    },
  },
  actions: {
    // ค้น billing ค้างชำระจากเลขกรมธรรม์ — คืน { items, invoiceRef }
    //   items     : array ของ billing ค้างชำระ (เอาไปเติมตะกร้า)
    //   invoiceRef: ข้อมูลใบวางบิล เมื่อกรมธรรม์อยู่ในใบวางบิลแล้ว (Datum) — ไม่งั้น null
    async lookup({ state }, policy) {
      state._lookupSeq += 1;
      const mySeq = state._lookupSeq;
      state.isLooking = true;
      try {
        const res = await LmgService.QuickPaymentLookup(policy);
        if (mySeq !== state._lookupSeq) return { items: [], invoiceRef: null };
        state.isLooking = false;
        return { items: res.data.Data || [], invoiceRef: res.data.Datum || null };
      } catch (err) {
        if (mySeq !== state._lookupSeq) return { items: [], invoiceRef: null };
        state.isLooking = false;
        return { items: [], invoiceRef: null };
      }
    },
    // สร้างใบวางบิล + ชำระเงิน atomic (payload = FormData) → คืน {InvoiceID, InvoiceNumber, ...}
    createPayment(_, payload) {
      return LmgService.QuickPaymentCreate(payload);
    },
    // ขอ/แนบ QR PromptPay ให้ใบวางบิล
    requestQR(_, payload) {
      return LmgService.QuickPaymentQR(payload);
    },
    async loadPromptPay({ commit }, payload) {
      try {
        const res = await LmgService.PromptPayAccountList(payload);
        commit("SET_PROMPTPAY", res.data.Data == null ? [] : res.data.Data);
      } catch (err) {
        commit("SET_PROMPTPAY", []);
      }
    },
    savePromptPay(_, payload) {
      return LmgService.PromptPayAccountCreate(payload);
    },
    updatePromptPay(_, { id, data }) {
      return LmgService.PromptPayAccountUpdate(id, data);
    },
  },
  getters: {
    getPaymentMethod(state) {
      return state.payment_method;
    },
    getPromptPay(state) {
      return state.promptpay;
    },
    isLooking(state) {
      return state.isLooking;
    },
  },
};

export default QuickPayModule;
